import React from 'react';
import styled from "styled-components";

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  background-color: transparent;
  width: 21rem;
  height: 29rem;

  
  h2 {
    padding-bottom: 2rem;
  }
`

const UserDetails = styled.div`
  .title {
    font-size: 2rem;
    line-height: 102%;
    font-weight: 400;
    padding-bottom: 1rem;
    padding-top: 1rem;
  }
  
  p {
    padding-left: 1rem;
    text-decoration: underline;
  }
  
  .user-name {
    font-size: 2.2rem;
    line-height: 102%;
    font-weight: 400;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  
`

const UserInfoCard = ({user}) => {
  return (
    <StyledCard>
      <h2>User Info</h2>
      <UserDetails>
        <div className={'user-name'}>{user.name}</div>
        <div className={'user-details'}>
          <div className={'title'}>Authorization:</div>
          <p>Role: Admin</p>
        </div>
        <div className={'user-details'}>
          <div className={'title'}>Email:</div>
          <p>{user.email}</p>
        </div>
      </UserDetails>
    </StyledCard>
  )
}

export default UserInfoCard;